export default class defaultModel {
  id: string;
  constructor({ id, ...attrs }) {
    this.id = (id || '').toString();
    if (attrs) {
      Object.assign(this, attrs);
    }
  }
}
